import useSeo from "@/lib/useSeo";
import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Check } from "lucide-react";
import MarketingShell from "@/components/marketing/MarketingShell";
import api from "@/lib/api";

export default function Unsubscribe() {
  useSeo({ title: "Unsubscribe", description: "Unsubscribe from ChangeOS readiness-check reminders.", path: "/unsubscribe" });
  const [params] = useSearchParams();
  const [done, setDone] = useState(false);
  useEffect(() => {
    const token = params.get("token") || "";
    api.get(`/public/unsubscribe?token=${encodeURIComponent(token)}`).catch(() => {}).finally(() => setDone(true));
  }, [params]);
  return (
    <MarketingShell>
      <section className="max-w-2xl mx-auto px-6 py-24" data-testid="unsubscribe-page">
        <div className="pp-card p-8">
          <div className="w-10 h-10 rounded-xl bg-accent-50 text-accent-700 flex items-center justify-center"><Check size={20} /></div>
          <h1 className="font-head text-3xl font-extrabold tracking-tight mt-5" data-testid="unsubscribe-message">
            {done ? "You're unsubscribed." : "Unsubscribing…"}
          </h1>
          <p className="text-subtle mt-3 leading-relaxed">You won't hear from us again about this check.</p>
          <div className="mt-6"><Link to="/" className="pp-btn-ghost">Back to ChangeOS</Link></div>
        </div>
      </section>
    </MarketingShell>
  );
}
